import { BaseClaraForPlannersEventTracking } from '@/modules/ai/models/segmentevents/BaseClaraForPlannersEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import type { AuthUser } from '@/modules/auth/models/AuthUser';

export class ClaraForPlannersChatClosedEventTracking extends BaseClaraForPlannersEventTracking {
  static eventName: string = SegmentEvent.CLARA_CHAT_CLOSED;

  durationSeconds: number;

  constructor(authUser: AuthUser | null, sessionId: string, openedAt: number) {
    super(authUser, sessionId);
    this.durationSeconds = Math.round((Date.now() - openedAt) / 1000);
  }
}
